import { useCallback } from 'react';
import { FetchBrandThemingContext } from "@trinity/chat-components/containers/Branding/Context.js";
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useAppSelector } from '@/store';

export const FetchBrandingProvider = ({ children }: { children: React.ReactNode }) => {

  const groupId = useAppSelector(state => state.group.id);

  const apiClient = useChatApiClient();

  const fetchBranding = useCallback(() => {
    return apiClient.groups.fetchBranding({
      groupId,
    });
  }, [apiClient, groupId]);

  return (
    <FetchBrandThemingContext.Provider value={fetchBranding}>
      {children}
    </FetchBrandThemingContext.Provider>
  );
};

export const BrandingContainer = (props: { children: React.ReactNode }) => {

  return (
    <FetchBrandingProvider>
      {props.children}
    </FetchBrandingProvider>
  );
}
